"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const IconCell = _ref => {
  let {
    columnKey,
    cellData,
    mobileHeaderValue
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "item-cell ".concat(columnKey, "-grid")
  }, mobileHeaderValue && /*#__PURE__*/_react.default.createElement("div", {
    className: "head-cell-mobile mr-2"
  }, mobileHeaderValue), cellData.icon);
};
var _default = exports.default = IconCell;